import { useRef, useState, useCallback, useMemo, useEffect } from 'react';
import { min, max } from 'd3-array';
import Fuse from 'fuse.js';
import { getElementOffset, hasContentOverflow } from '@keen.io/charts-utils';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var tslib = {exports: {}};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

(function (module) {
/* global global, define, System, Reflect, Promise */
var __extends;
var __assign;
var __rest;
var __decorate;
var __param;
var __metadata;
var __awaiter;
var __generator;
var __exportStar;
var __values;
var __read;
var __spread;
var __spreadArrays;
var __await;
var __asyncGenerator;
var __asyncDelegator;
var __asyncValues;
var __makeTemplateObject;
var __importStar;
var __importDefault;
var __classPrivateFieldGet;
var __classPrivateFieldSet;
var __createBinding;
(function (factory) {
    var root = typeof commonjsGlobal === "object" ? commonjsGlobal : typeof self === "object" ? self : typeof this === "object" ? this : {};
    {
        factory(createExporter(root, createExporter(module.exports)));
    }
    function createExporter(exports, previous) {
        if (exports !== root) {
            if (typeof Object.create === "function") {
                Object.defineProperty(exports, "__esModule", { value: true });
            }
            else {
                exports.__esModule = true;
            }
        }
        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
    }
})
(function (exporter) {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

    __extends = function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };

    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };

    __rest = function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    };

    __decorate = function (decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    __param = function (paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    };

    __metadata = function (metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    };

    __awaiter = function (thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };

    __generator = function (thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    };

    __createBinding = function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    };

    __exportStar = function (m, exports) {
        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
    };

    __values = function (o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };

    __read = function (o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    };

    __spread = function () {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    };

    __spreadArrays = function () {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    __await = function (v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    };

    __asyncGenerator = function (thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    };

    __asyncDelegator = function (o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    };

    __asyncValues = function (o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    };

    __makeTemplateObject = function (cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    __importStar = function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result["default"] = mod;
        return result;
    };

    __importDefault = function (mod) {
        return (mod && mod.__esModule) ? mod : { "default": mod };
    };

    __classPrivateFieldGet = function (receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    };

    __classPrivateFieldSet = function (receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    };

    exporter("__extends", __extends);
    exporter("__assign", __assign);
    exporter("__rest", __rest);
    exporter("__decorate", __decorate);
    exporter("__param", __param);
    exporter("__metadata", __metadata);
    exporter("__awaiter", __awaiter);
    exporter("__generator", __generator);
    exporter("__exportStar", __exportStar);
    exporter("__createBinding", __createBinding);
    exporter("__values", __values);
    exporter("__read", __read);
    exporter("__spread", __spread);
    exporter("__spreadArrays", __spreadArrays);
    exporter("__await", __await);
    exporter("__asyncGenerator", __asyncGenerator);
    exporter("__asyncDelegator", __asyncDelegator);
    exporter("__asyncValues", __asyncValues);
    exporter("__makeTemplateObject", __makeTemplateObject);
    exporter("__importStar", __importStar);
    exporter("__importDefault", __importDefault);
    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
});
}(tslib));

var PREFIX = '@keen.io/dataviz';
var useTooltip = function (container, computeRelativeToTarget, allowContainerOverflow, tooltipRef) {
  if (allowContainerOverflow === void 0) {
    allowContainerOverflow = true;
  }

  var tooltipUpdate = useRef(null);

  var _a = tslib.exports.__read(useState({
    selectors: null,
    meta: null,
    visible: false,
    x: 0,
    y: 0
  }), 2),
      tooltip = _a[0],
      setTooltip = _a[1];

  var updateTooltipPosition = useCallback(function (e, selectors, meta) {
    if (tooltipUpdate.current) cancelAnimationFrame(tooltipUpdate.current);
    e.persist();

    var _a = container.current.getBoundingClientRect(),
        top = _a.top,
        left = _a.left,
        width = _a.width,
        height = _a.height;

    var maxOffsetX = width;
    var maxOffsetY = height;
    var tooltipX = e.pageX - left - window.scrollX;
    var tooltipY = e.pageY - top - window.scrollY;

    if (computeRelativeToTarget) {
      var eventTarget = e.target;
      var targetRect = eventTarget.getBoundingClientRect();
      tooltipX = Math.abs(left - targetRect.left) + targetRect.width / 2;
      tooltipY = Math.abs(top - targetRect.top) + targetRect.height / 2;
    }

    if (!allowContainerOverflow && !tooltipRef) {
      throw new Error(PREFIX + " - tooltipRef is required");
    }

    if (!allowContainerOverflow && (tooltipRef === null || tooltipRef === void 0 ? void 0 : tooltipRef.current)) {
      var _b = tooltipRef.current.getBoundingClientRect(),
          tooltipWidth = _b.width,
          tooltipHeight = _b.height;

      maxOffsetX = width - tooltipWidth;
      maxOffsetY = height - tooltipHeight;
    }

    if (tooltipX > maxOffsetX) {
      tooltipX = maxOffsetX;
    }

    if (tooltipY > maxOffsetY) {
      tooltipY = maxOffsetY;
    }

    tooltipUpdate.current = requestAnimationFrame(function () {
      setTooltip({
        visible: true,
        selectors: selectors,
        meta: meta,
        x: tooltipX,
        y: tooltipY
      });
    });
  }, [container, computeRelativeToTarget, tooltipRef]);
  var hideTooltip = useCallback(function () {
    if (tooltipUpdate.current) cancelAnimationFrame(tooltipUpdate.current);
    setTooltip(function (currentState) {
      return tslib.exports.__assign(tslib.exports.__assign({}, currentState), {
        visible: false,
        selectors: null
      });
    });
  }, []);
  return {
    hideTooltip: hideTooltip,
    updateTooltipPosition: updateTooltipPosition,
    tooltipMeta: tooltip.meta,
    tooltipSelectors: tooltip.selectors,
    tooltipPosition: {
      x: tooltip.x,
      y: tooltip.y
    },
    tooltipVisible: tooltip.visible
  };
};

var useSlider = function (data, keys) {
  var _a = useMemo(function () {
    var dataArray = [];
    data.forEach(function (item) {
      for (var property in item) {
        if (typeof item[property] === 'number' && keys.includes(property)) {
          dataArray.push(item[property]);
        }
      }
    });
    return {
      min: min(dataArray),
      max: max(dataArray)
    };
  }, [keys, data]),
      min$1 = _a.min,
      max$1 = _a.max;

  return {
    min: min$1,
    max: max$1
  };
};

var useLegend = function () {
  var _a = tslib.exports.__read(useState([]), 2),
      keys = _a[0],
      setKeys = _a[1];

  var updateKeys = function (key, disabled) {
    if (disabled) {
      setKeys(function (keys) {
        return tslib.exports.__spread(keys, [key]);
      });
    } else {
      setKeys(function (keys) {
        return keys.filter(function (keyName) {
          return keyName !== key;
        });
      });
    }
  };

  return {
    disabledKeys: keys,
    updateKeys: updateKeys
  };
};

var defaultOptions = {
  keys: ['label', 'value'],
  threshold: 0.3
};
var useSearch = function (collection, callback, options, debounceTime) {
  if (options === void 0) {
    options = defaultOptions;
  }

  if (debounceTime === void 0) {
    debounceTime = 200;
  }

  var _a = tslib.exports.__read(useState(null), 2),
      searchPhrase = _a[0],
      setSearchPhrase = _a[1];

  var fuseSearch = useRef(new Fuse(collection, options));
  var searchDebounce = useRef(null);
  var clearSearchPhrase = useCallback(function () {
    setSearchPhrase(null);
  }, []);
  useEffect(function () {
    fuseSearch.current = new Fuse(collection, options);
  }, [collection, options]);
  var searchHandler = useCallback(function (e) {
    var value = e.currentTarget.value;
    if (searchDebounce.current) clearTimeout(searchDebounce.current);
    searchDebounce.current = setTimeout(function () {
      var results = fuseSearch.current.search(value).map(function (_a) {
        var item = _a.item;
        return item;
      });
      setSearchPhrase(value);
      callback(results, value);
    }, debounceTime);
  }, [fuseSearch, collection]);
  return {
    clearSearchPhrase: clearSearchPhrase,
    searchPhrase: searchPhrase,
    searchHandler: searchHandler
  };
};

var useOnClickOutside = function (containerRef, onClickOutside) {
  var outsideClick = useCallback(function (e) {
    if (containerRef.current && !containerRef.current.contains(e.target)) {
      onClickOutside();
    }
  }, [containerRef, onClickOutside]);
  useEffect(function () {
    document.addEventListener('click', outsideClick);
    return function () {
      return document.removeEventListener('click', outsideClick);
    };
  }, [containerRef, onClickOutside]);
};

var useDynamicContentPosition = function (parentRef) {
  var _a = tslib.exports.__read(useState({
    x: 0,
    y: 0,
    width: 0
  }), 2),
      contentPosition = _a[0],
      setContentPosition = _a[1];

  var setPosition = function () {
    if (parentRef.current) {
      var parentRect = parentRef.current.getBoundingClientRect();
      setContentPosition({
        x: parentRect.x,
        y: parentRect.y + window.scrollY + parentRect.height,
        width: parentRect.width
      });
    }
  };

  return {
    setPosition: setPosition,
    contentPosition: contentPosition
  };
};

var useOnParentScroll = function (scrollableContainerRef, onScroll) {
  useEffect(function () {
    var _a;

    (_a = scrollableContainerRef === null || scrollableContainerRef === void 0 ? void 0 : scrollableContainerRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', onScroll);
    return function () {
      var _a;

      (_a = scrollableContainerRef === null || scrollableContainerRef === void 0 ? void 0 : scrollableContainerRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', onScroll);
    };
  }, [scrollableContainerRef]);
};

var useDataSeriesOffset = function (colorsLenght, legendEnabled) {
  var _a = tslib.exports.__read(useState([0, colorsLenght]), 2),
      dataSeriesOffset = _a[0],
      setDataSeriesOffset = _a[1];

  useEffect(function () {
    if (!legendEnabled) {
      setDataSeriesOffset([0, colorsLenght]);
    }
  }, [legendEnabled]);
  return {
    setDataSeriesOffset: setDataSeriesOffset,
    dataSeriesOffset: dataSeriesOffset
  };
};

var useKeypress = function (_a) {
  var addEventListenerCondition = _a.addEventListenerCondition,
      eventListenerDependencies = _a.eventListenerDependencies,
      handledKeys = _a.handledKeys,
      keyboardAction = _a.keyboardAction;

  var keyboardHandler = function (e) {
    var keyCode = e.keyCode;
    if (handledKeys.includes(keyCode)) keyboardAction(e, keyCode);
  };

  useEffect(function () {
    if (addEventListenerCondition) {
      document.addEventListener('keydown', keyboardHandler);
    }

    return function () {
      document.removeEventListener('keydown', keyboardHandler);
    };
  }, [eventListenerDependencies]);
};

var useScrollOverflowHandler = function (containerRef) {
  var _a = tslib.exports.__read(useState(0), 2),
      maxScroll = _a[0],
      setMaxScroll = _a[1];

  var _b = tslib.exports.__read(useState({
    overflowLeft: false,
    overflowRight: false
  }), 2),
      _c = _b[0],
      overflowLeft = _c.overflowLeft,
      overflowRight = _c.overflowRight,
      setOverflow = _b[1];

  var calculateMaxScroll = useCallback(function () {
    var _a = getElementOffset(containerRef.current, 'horizontal'),
        offset = _a.offset,
        offsetScroll = _a.scroll;

    setMaxScroll(offsetScroll - offset);
  }, [containerRef.current]);
  var scrollHandler = useCallback(function (e) {
    var offset = e.currentTarget.scrollLeft;
    var hasOverflowLeft = offset > 0;
    var hasOverflowRight = offset < maxScroll;

    if (hasOverflowLeft !== overflowLeft || hasOverflowRight !== overflowRight) {
      setOverflow({
        overflowLeft: hasOverflowLeft,
        overflowRight: hasOverflowRight
      });
    }
  }, [maxScroll, overflowLeft, overflowRight]);
  useEffect(function () {
    var hasOverflow = hasContentOverflow('horizontal', containerRef.current);

    if (hasOverflow) {
      setOverflow(function (state) {
        return tslib.exports.__assign(tslib.exports.__assign({}, state), {
          overflowRight: true
        });
      });
    }

    calculateMaxScroll();
  }, [containerRef.current]);
  return {
    overflowRight: overflowRight,
    overflowLeft: overflowLeft,
    scrollHandler: scrollHandler
  };
};

export { useDataSeriesOffset, useDynamicContentPosition, useKeypress, useLegend, useOnClickOutside, useOnParentScroll, useScrollOverflowHandler, useSearch, useSlider, useTooltip };
//# sourceMappingURL=index.esm.js.map
